import { useNavigate, useSearch } from '@tanstack/react-location'
import Input from 'MediaManager/components/Form/Input'
import ScreenLayout from 'MediaManager/layouts/ScreenLayout'
import { getUnitType } from 'MediaManager/services/property'
import { deleteUnit } from 'MediaManager/services/units'
import React, { useCallback } from 'react'
import Button from 'shared/components/Button'
import DataTable from 'shared/components/DataTable'
import Loader from 'shared/components/Loader'
import { useRequest } from 'shared/hooks/useRequest'

function ManageLineUnitsScreen(props) {
  const { line } = useSearch()

  const navigate = useNavigate()

  const getData = useCallback(async () => {
    const { data } = await getUnitType(line)
    return data.unit_types[0]
  }, [line])

  const { data, loading, refresh } = useRequest(getData)

  const actions = [
    {
      label: 'Add unit',
      action: () => {
        navigate({ to: `/units/add?line=${line}` })
      },
    },
  ]

  async function onDelete(id) {
    await deleteUnit(id)
    refresh()
  }

  const table = [
    {
      label: 'ID',
      data: (unit) => <span className='underline'>{unit.id}</span>,
    },
    {
      label: 'Unit number',
      data: (unit) => `#${unit.unit_number}`,
    },
    {
      label: 'Name',
      data: (unit) => <span className='underline'>{unit.name}</span>,
    },
    {
      label: 'Building',
      data: (unit) => unit.building_name,
    },
    {
      label: 'Floor',
      data: (unit) => unit.floor,
    },
    {
      label: 'Actions',
      data: (unit) => (
        <div className="flex justify-end">
          <Button size="small" variant="secondary" rounded className="ml-[16px] !w-max !min-w-max">
            Edit
          </Button>
          <Button
            size="small"
            variant="secondary"
            rounded
            onClick={(e) => {
              e.stopPropagation()
              if (window.confirm('Are you sure you want to delete this unit?')) {
                onDelete(unit.id)
              }
            }}
            className="ml-[16px] !w-max !min-w-max"
          >
            Delete
          </Button>
        </div>
      ),
    },
  ]

  return (
    <ScreenLayout title="Line units">
      {loading && (
        <div>
          <Loader />
        </div>
      )}
      {!loading && (
        <>
          <div>
            <Input label="Property" disabled value={data.property.property_name} />
            <Input wrapClassName="mt-[16px]" label="Line" disabled value={data.name} />
          </div>
          <div className="mt-[16px]">
            <DataTable
              actions={actions}
              onRowClick={(data) => {
                navigate({ to: `/units/edit?line=${line}&id=${data.id}` })
              }}
              data={data.units}
              title="Units"
              structure={table}
            />
          </div>
        </>
      )}
    </ScreenLayout>
  )
}

export default ManageLineUnitsScreen
